import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

// NativeDateAdapter displays dates using MAT_DATE_LOCALE (en-GB => DD/MM/YYYY) but parses typed
// text with Date.parse (MM/DD/YYYY). This adapter parses typed dates in the same DD/MM/YYYY format.
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  override parse(value: any, parseFormat?: any): Date | null {
    if (typeof value !== 'string') {
      return super.parse(value, parseFormat);
    }

    const text = value.trim();
    if (!text) {
      return null;
    }

    const match = text.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (!match) {
      return this.invalid();
    }

    const day = Number(match[1]);
    const month = Number(match[2]) - 1;
    const year = Number(match[3]);
    const date = new Date(year, month, day);

    // Reject overflowing values such as 31/02/2026 instead of rolling them into the next month
    if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
      return this.invalid();
    }

    return date;
  }
}
